import { render, staticRenderFns } from "./DashboardChecklistCard.vue?vue&type=template&id=21889742&scoped=true&"
import script from "./DashboardChecklistCard.vue?vue&type=script&lang=js&"
export * from "./DashboardChecklistCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardChecklistCard.vue?vue&type=style&index=0&id=21889742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21889742",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VChip,VCol,VRow,VSpacer})
